import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

/**
 * Specialized skeleton for inbox task items
 * Matches the layout of actual inbox task cards with checkbox, title, description, metadata
 */
@Component({
  selector: 'app-inbox-task-skeleton',
  standalone: true,
  imports: [CommonModule, NzSkeletonModule],
  templateUrl: './inbox-task-skeleton.component.html',
  styleUrls: ['./inbox-task-skeleton.component.scss'],
})
export class InboxTaskSkeletonComponent {
  /** Number of skeleton items to render */
  @Input() count = 3;
  
  get skeletonItems(): number[] {
    return Array(this.count).fill(0);
  }
}
